<template>
  <div>
    <!-- <SpFinder
      id="1"
      ref="finder"
      :url="{
        data: requestUrl
      }"
      :search="[{ key: 'searchname', name: '', slot: 'searchname' }]"
      :hooks="{
        beforeSearch: beforeSearch
      }"
      title="数据"
      :columns="columns"
      :actions="actions"
      @reset="onFinderResetGroup"
    >
      <template v-slot:searchname>
        <el-input
          v-model="keyword"
          placeholder="请输入名称"
        />
      </template>
    </SpFinder> -->
    <!-- 执行群聊 -->
    <template v-if="showList">
      <ShipSopList />
    </template>
    <template v-else>
      <NoShipSop />
    </template>
  </div>
</template>
<script>
import { getSopList } from '@/api/membership/membershipsop'
export default {
  components: {
    'NoShipSop': () => import('./comps/noshipsop'),
    'ShipSopList': () => import('./comps/shipsoplist')
  },
  data () {
    return {
      params: {
        page: 1,
        page_size: 10,
        rule_name: ''
      },
      showList: true
    }
  },

  created () {
    getSopList(this.params).then((res) => {
      if (res.list.length === 0) {
        this.showList = false
      }
    })
  },

  methods: {}
}
</script>
<style lang="scss" scoped></style>
